/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {ParentBox, relayWrap} from '../../box-utils/ParentBox.react.js';
import BoxDecorator from '../../box-utils/BoxDecorator.react';
import {viewWithDataGetPrimaryData} from '../../box-utils/PrimaryData';
import EmptyContent from '../system/EmptyContent.react';
import config from '../../../../common/config';
import ResizeSensor from 'css-element-queries/src/ResizeSensor';
import {FormattedMessage} from 'react-intl';
import getImage from '../getImage';
import PanelColumns from '../system/PanelColumns.react';

import './googleMap.scss';

class GoogleMap extends ParentBox {

	static handlerName = "google-map";
	static MAX_HEIGHT = 200;

	static propTypes = {
		isPreview: PropTypes.bool,
		viewWithData: PropTypes.object.isRequired,
	};

	constructor(props) {

		super(props);

		if (props.isPreview) {
			this.data = GoogleMap.getPreviewData(props);
		}
		else {
			this.data = props.viewWithData;
		}

		this.mapAddresses = GoogleMap.getAddress(this.data).map(token => token.join(', '));

		this.state = {
			boxHeight: 125,
			boxWidth: 640,
			loading: true,
			imageFound: {}
		};
	}

	getIcon() {
		return "google-maps";
	}

	getServiceName() {
		return "Google Maps";
	}

	computeHeight() {
		let self = this;

		// don't refresh height when the address wan't found
		if (this.state.loading === false && !this.hasAnyImage()) {
			return;
		}

		//wait for a paint to do scrolly stuff
		window.requestAnimationFrame(() => {
			if (self.refs.boxElement) {
				let domElement = self.refs.boxElement._reactInternalInstance._hostParent.getHostNode();
				let height = domElement.clientHeight;
				let width = domElement.clientWidth;

				if (height > GoogleMap.MAX_HEIGHT) {
					height = GoogleMap.MAX_HEIGHT;
				}

				if (height && width) {
					width = width - 32;

					self.setState({
						// boxHeight: height,
						boxWidth: Math.min(width, 640)
					});
				}
			}
		});
	}

	componentDidMount() {
		let self = this;
		let element = this.refs.boxElement._reactInternalInstance._hostParent.getHostNode();

		if (!element.closest('.dataSource-list')) {
			new ResizeSensor(element.parentElement, () => {
				/* delay update to skip too frequent updates */
				if (!self.resizeTimeout) {
					self.resizeTimeout = setTimeout(() => {
						self.resizeTimeout = null;
						self.computeHeight();
					}, 300);
				}
			});
		}

		setTimeout(() => {
			self.computeHeight();
		}, 100);
	}

	hasAnyImage() {
		return Object.keys(this.state.imageFound).some(img => img !== false);
	}

	static getAddress(viewWithData) {
		let allData = viewWithData.data;

		if (!allData) {
			return [];
		}

		let allTokens = [];

		allData.forEach(company => {
			let tokens = [];
			let data = company;

			/* added support for latitude/longitude */
			if (data['com.dativery.model.entities.locations@latitude'] && data['com.dativery.model.entities.locations@longitude']) {
				tokens = [
					data['com.dativery.model.entities.locations@latitude'],
					data['com.dativery.model.entities.locations@longitude']
				];

				if (tokens.length) {
					allTokens.push(tokens);
				}
				return;
			}

			if (data['com.dativery.model.entities.locations@coordinates']) {
				tokens = [
					data['com.dativery.model.entities.locations@coordinates']
				];

				if (tokens.length) {
					allTokens.push(tokens);
				}
				return;
			}

			tokens = [
				data['com.dativery.model.components.seatAddresses@saAddress1'],
				data['com.dativery.model.components.seatAddresses@saAddress2'],
				data['com.dativery.model.components.seatAddresses@saStreetNameAndNumber'],
				data['com.dativery.model.components.seatAddresses@saStreet'],
				data['com.dativery.model.components.seatAddresses@saStreetNo'],
				data['com.dativery.model.components.seatAddresses@saCity'],
				data['com.dativery.model.components.seatAddresses@saPostalCode'],
				data['com.dativery.model.components.seatAddresses@saState'],
				data['com.dativery.model.components.seatAddresses@saCountry'],
			];

			if (!GoogleMap.isStreetView(viewWithData)) {
				tokens.unshift(data['com.dativery.model.entities.companies@name']);
			}

			tokens = tokens.filter((row) => !!row);

			if (tokens.length <= 2) {
				tokens = [...tokens,
					data['com.dativery.model.components.genericAddresses@gaAddress1'],
					data['com.dativery.model.components.genericAddresses@gaAddress2'],
					data['com.dativery.model.components.genericAddresses@gaStreetNameAndNumber'],
					data['com.dativery.model.components.genericAddresses@gaStreet'],
					data['com.dativery.model.components.genericAddresses@gaStreetNo'],
					data['com.dativery.model.components.genericAddresses@gaCity'],
					data['com.dativery.model.components.genericAddresses@gaPostalCode'],
					data['com.dativery.model.components.genericAddresses@gaState'],
					data['com.dativery.model.components.genericAddresses@gaCountry'],
				];
			}

			tokens = tokens.filter((row) => !!row);

			if (tokens.length) {
				allTokens.push(tokens);
			}
		});

		return allTokens;
	}

	static isEmpty(viewWithData) {
		viewWithData.data = viewWithDataGetPrimaryData(viewWithData);
		let addressToken = GoogleMap.getAddress(viewWithData);

		return addressToken.length === 0;
	}

	static getPreviewData(props) {
		// has to accept viewWithData even in preview as ve decide from it, if it should be streetview or not
		let viewWithData = props.viewWithData;

		viewWithData.data = [
			{
				"com.dativery.model.components.seatAddresses@saCity": "Prague",
				"com.dativery.model.components.seatAddresses@saCountry": "Czech Republic"
			}
		];

		return viewWithData;
	}

	static getStyle(data) {
		let style = "default";

		if (data.view && data.view.template) {
			let template = JSON.parse(data.view.template);
			if (template.style) {
				style = template.style;
			}
		}
		else if (data.view && data.view.entityViewDef && data.view.entityViewDef.template) {
			let template = JSON.parse(data.view.entityViewDef.template);
			if (template.type) {
				style = template.type;
			}
		}

		return style;
	}

	getImageUrl(mapAddress) {
		/* show selected style */
		if (GoogleMap.isStreetView(this.data)) {
			return "https://maps.googleapis.com/maps/api/streetview?size=" + this.state.boxWidth + "x" + this.state.boxHeight + "&location=" + encodeURIComponent(mapAddress) + "&pitch=10&key=" + config.GOOGLE_KEY;
		}

		return "https://maps.googleapis.com/maps/api/staticmap?center=" + encodeURIComponent(mapAddress) + "&markers=color:red%7C" + encodeURIComponent(mapAddress) + "&zoom=15&size=" + this.state.boxWidth + "x" + this.state.boxHeight + "&maptype=roadmap&key=" + config.GOOGLE_KEY;
	}

	static isStreetView(data) {
		let style = GoogleMap.getStyle(data);

		return style === 'streetview';
	}

	getImage(mapAddress) {
		let url = this.getImageUrl(mapAddress);

		getImage(url, (xhr) => {
			let warning;

			try {
				warning = xhr.getResponseHeader('x-staticmap-api-warning');
			} catch (e) {}

			return warning && warning.indexOf('Error geocoding') === 0;
		}).then((imageBlobUrl) => {
			let imageFound = this.state.imageFound;
			imageFound[mapAddress] = imageBlobUrl;

			let isLoading = this.mapAddresses.length !== Object.keys(imageFound).length;

			this.setState({
				imageFound: imageFound,
				loading: isLoading
			});
		}).catch(() => {
			let imageFound = this.state.imageFound;
			imageFound[mapAddress] = false;

			let isLoading = this.mapAddresses.length !== Object.keys(imageFound).length;

			this.setState({
				imageFound: imageFound,
				loading: isLoading
			});
		});
	}

	render() {
		if (this.state.loading) {
			this.mapAddresses.forEach(mapAddress => {
				this.getImage(mapAddress);
			});

			return (
				<BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} ref="boxElement" title={this.getServiceName()}>
					<EmptyContent message={<FormattedMessage defaultMessage="Loading" id="googleMapsBox.loading" />} />
				</BoxDecorator>
			);
		}

		if (!this.hasAnyImage()) {
			return (
				<BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} ref="boxElement" title={this.getServiceName()}>
					<EmptyContent message={<span title={this.mapAddresses.join(' | ')}><FormattedMessage defaultMessage="Address not found by Google Maps" id="googleMapsBox.notFound" /></span>} />
				</BoxDecorator>
			);
		}

		if (this.mapAddresses.length === 0) {
			return (
				<BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} ref="boxElement" title={this.getServiceName()}>
					<EmptyContent />
				</BoxDecorator>
			);
		}

		if (this.mapAddresses.length === 1) {
			let mapAddress = this.mapAddresses[0];
			return (
				<BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} ref="boxElement" title={this.getServiceName()}>
					<div className="googleMap" style={{backgroundImage: 'url("' + this.state.imageFound[mapAddress] + '")'}}>
						<div className="googleMapLink">
							<a href={"https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(mapAddress)} target="_blank">
								<FormattedMessage defaultMessage="View larger map" id="googleMapsBox.linkToMap" />
							</a>
						</div>
					</div>
				</BoxDecorator>
			);
		}

		return (
			<BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} ref="boxElement" title={this.getServiceName()}>
				<PanelColumns>
					{this.mapAddresses.map((mapAddress, idx) => {
						return (
							<div className="googleMap" key={idx} style={{backgroundImage: 'url("' + this.state.imageFound[mapAddress] + '")'}}>
								<div className="googleMapLink">
									<a href={"https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(mapAddress)} target="_blank">
										<FormattedMessage defaultMessage="View larger map" id="googleMapsBox.linkToMap" />
									</a>
								</div>
							</div>
						);
					})}
				</PanelColumns>
			</BoxDecorator>
		);
	}
}

export default relayWrap(GoogleMap);
